module.exports = __webpack_public_path__ + "img/组 290.534c779a.png";